// extracted by mini-css-extract-plugin
export var logo = "LogoBoard-module--logo--2023a";
export var logoBoard = "LogoBoard-module--logoBoard--0772b";